import axios from 'axios';

export default {
    getEvents(context) {
        var options = {
            url: window.apiUrl + '/journey-events',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getAlerts(context) {
        var options = {
            url: window.apiUrl + '/course-alerts',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/journeys/index.js